var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 28, height: 28, viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "suspended_svg__a" },
                React.createElement("path", { d: "M13 0a1 1 0 010 2H1a1 1 0 110-2h12z" })),
            React.createElement("clipPath", { id: "suspended_svg__b" },
                React.createElement("path", { d: "M8 0a1 1 0 110 2H1a1 1 0 110-2h7z" })),
            React.createElement("clipPath", { id: "suspended_svg__c" },
                React.createElement("path", { d: "M10.909.333l2.855 1.654a2.486 2.486 0 01.904 3.39l-7.31 12.706a.826.826 0 01-.29.296l-5.82 3.503A.822.822 0 010 21.16l.112-6.811a.83.83 0 01.11-.4l7.31-12.707a2.467 2.467 0 013.377-.908zM2.347 15.539a.825.825 0 00-.843.701l-.009.097-.081 2.35a.823.823 0 001.176.777l.084-.046 1.988-1.247a.83.83 0 00.056-1.365l-.081-.052-1.906-1.105a.822.822 0 00-.384-.11zM7.364 4.852l-.053.081L2.24 13.75l4.282 2.482 5.071-8.817a.83.83 0 00-.221-1.076l-.08-.053L8.436 4.63a.822.822 0 00-1.073.222z" }))),
        React.createElement("g", { clipPath: "url(#suspended_svg__a)", transform: "translate(3 5)" },
            React.createElement("path", { fill: "#4A4A4A", d: "M0 0h14v2H0V0z" })),
        React.createElement("g", { clipPath: "url(#suspended_svg__b)", transform: "translate(3 9)" },
            React.createElement("path", { fill: "#4A4A4A", d: "M0 0h9v2H0V0z" })),
        React.createElement("g", { clipPath: "url(#suspended_svg__c)", transform: "rotate(15 -2.692 50.979)" },
            React.createElement("path", { fill: "#4A4A4A", d: "M0 0h15v22H0V0z" }))));
});
